<!--
 * @Description: 品牌列表
 * @Author: 琢磨先生
 * @Date: 2022-06-06 16:55:31
 * @LastEditors: 琢磨先生
 * @LastEditTime: 2022-09-14 03:28:33
-->


<template>
  <el-card class="box">
    <el-form ref="query" :model="query" :inline="true">
      <el-form-item label="关键字">
        <el-input
          v-model="query.q"
          placeholder="请输入名称"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="状态">
        <el-select
          v-model="query.is_stop"
          clearable
          placeholder=""
          style="width: 120px"
        >
          <el-option label="正常" :value="false"></el-option>
          <el-option label="停用" :value="true"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" round @click="onSearch" icon="search"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
    <el-button type="primary" size="small" @click="onEdit()" round icon="plus"
      >新增</el-button
    >
  </el-card>
  <el-card class="box" v-loading="loading">
    <el-table :data="tableData.data">
      <el-table-column label="编号" prop="id" width="100"></el-table-column>
      <el-table-column
        label="中文名称"
        prop="name"
        width="200"
      ></el-table-column>
      <el-table-column
        label="英文名"
        prop="en_name"
        width="200"
      ></el-table-column>
      <el-table-column label="关联类目">
        <template #default="scope">
          <el-tag
            type=""
            v-for="item in scope.row.categories"
            :key="item.id"
             style="margin-right:20px;"
            >{{ item.full_name }}</el-tag
          >
        </template>
      </el-table-column>

      <el-table-column label="状态" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.is_stop ? 'danger' : 'success'">{{
            scope.row.is_stop ? "停用" : "正常"
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_at" width="180">
      </el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <el-button type="primary" link size="small" @click="onEdit(scope.row)"
            >修改</el-button
          >
          <el-popconfirm
            v-if="!scope.row.is_super"
            title="您确定要删除？"
            @confirm="onDelete(scope.row)"
          >
            <template #reference>
              <el-button size="small" type="danger" link class="btn-del"
                >删除</el-button
              >
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      v-if="tableData.counts > 0"
      @size-change="pageSizeChange"
      @current-change="pageCurrentChange"
      :current-page="query.pageIndex"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="tableData.counts"
    >
    </el-pagination>
  </el-card>
  <edit-brand :item="current" @change="loadData"></edit-brand>
</template>

<script>
import EditBrand from "./edit_brand.vue";

export default {
  components: {
    EditBrand,
  },
  data() {
    return {
      loading: false,
      query: {
        pageIndex: 1,
        pageSize: 20,
        order: {
          sort: "",
          fieldName: "",
        },
        q: "",
      },
      tableData: {
        counts: 0,
      },
      current: null,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    /**
     * 查询搜索
     */
    onSearch() {
      this.query.pageIndex = 1;
      this.loadData();
    },
    /**
     * 加载数据
     */
    loadData() {
      this.loading = true;
      this.$http.post("admin/v1/brand", this.query).then((res) => {
        if (res.code == 0) {
          this.tableData = res.data;
        }
        this.loading = false;
      });
    },
    /**
     * 新增、修改
     */
    onEdit(item) {
      this.current = item ? item : {};
    },
    /**
     * 删除
     */
    onDelete(item) {
      this.$http.get("/admin/v1/brand/del?id=" + item.id).then((res) => {
        if (res.code == 0) {
          this.$message({ type: "success", message: res.msg });
          this.loadData();
        }
      });
    },
    /**
     * 排序
     */
    onSort(e) {
      if (e.prop) {
        this.query.order.sort = e.order;
        this.query.order.fieldName = e.prop;
        this.loadData();
      }
    },
    /**
     * 分页页数更改
     */
    pageSizeChange(val) {
      this.query.pageSize = val;
      this.loadData();
    },
    /**
     * 分页页码更改
     */
    pageCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    }, 
    
  },
};
</script>

<style lang="scss" scoped>
</style>